
export default {
    namespaced: true,
    state: {
        chooseFromPage: '',
    },
    mutations: {},
    actions: {
        resetData({ state }) {
            state.chooseFromPage = '';
        }
    }
}